import { IconButton, useTheme } from "@mui/material";
import { Send } from "lucide-react";
import type { FC } from "react";

type Props = {
	onClick: () => void;
	active: boolean;
};

export const ChatComposerSendButton: FC<Props> = ({ onClick, active }) => {
	const theme = useTheme();

	return (
		<IconButton
			variant={active ? "fab" : "solid"}
			onPointerDown={(event) => event.preventDefault()}
			onClick={onClick}
			disabled={!active}
			sx={{ width: 36, height: 36 }}
		>
			<Send size={theme.iconSize.sm} />
		</IconButton>
	);
};
